/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 29.08.2016.
 */

import React, {Component} from 'react';
import {connect} from 'react-redux';
import { browserHistory } from 'react-router';
import {bindActionCreators} from 'redux';
import {VelocityComponent} from 'velocity-react';


import DocumentTitle from 'react-document-title';

import _get from 'lodash/get';

import Profile from '../components/ShowcaseCollection/Profile';

import {OpenProfileFor} from '../actions/common/actions-common';
import {GetPackages} from '../actions/collection/actions-collection';
import {FetchAssetById} from '../actions/asset/action-asset';

class AssetRoute extends Component {
  constructor(props) {
    super(props);

    this.state = {
      positionFromQuery: 0,
      showProfile: false
    };
  }

  componentWillMount() {
    this.props.GetPackages();

    this.setState({
      showProfile: true
    });

    if (!this.props.asset) {

      this.props.FetchAssetById(_get(this.props, 'params.asset_id'));
    }

    this.props.OpenProfileFor('asset-profile');
  }

  componentWillReceiveProps(newProps) {

    if (_get(newProps, 'params.asset_id') !== _get(this.props, 'params.asset_id') && !newProps.asset) {

      this.props.FetchAssetById(_get(newProps, 'params.asset_id'));
    }

    if (newProps.globalProfile && newProps.globalProfile !== 'asset-profile') {

      this.setState({
        showProfile: false
      });
    }
  }

  _onClose() {

    browserHistory.goBack();
  }

  render() {
    if (!this.props.asset) {

      return null;
    }

    let animationOnExpand = {
      marginTop: 0,
      marginBottom: '6px'
    };

    return (<DocumentTitle title={_get(this.props, 'asset.title', 'Content')}>
      {this.state.showProfile && <VelocityComponent animation={animationOnExpand} duration={650}>
        <Profile entity={this.props.asset} onClose={this._onClose.bind(this)} />
      </VelocityComponent>}
    </DocumentTitle>);
  }
}

const mapStateToProps = ({assets, common: {profile}}, ownProps) => {
  let asset = _get(assets, _get(ownProps, 'params.asset_id'));

  return {
    asset: asset,
    globalProfile: profile
  }
};

const mapDispatchToProps = function (dispatch) {

  return bindActionCreators({GetPackages, FetchAssetById, OpenProfileFor}, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(AssetRoute);



// WEBPACK FOOTER //
// ./src/routes/asset-route.js